import React, { useContext } from 'react'
import { Context } from '../'

export default function SplitViewSidebarBackdrop() {
    const context = useContext(Context)

    return (
        <figure
            className='svSidebarBackdrop'
            onClick={context.sidebar.toggle} />
    )
}
